export default (detailObject) => {
    const { carData, heading, insMediaServer } = detailObject;
    return { dataList: carData, heading, insMediaServer };
};
